var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardPanel',{attrs:{"title":"楼栋收费排行（TOP5）","meta":"单位：元"}},[_c('div',{ref:"chart",staticClass:"ranking-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }